import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-payment-dialog',
  templateUrl: './payment-dialog.component.html',
  styleUrls: ['./payment-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentDialogComponent implements OnInit {

  private translatePipe = new TranslatePipe(this.translate, this.cd);

  public paymentFormGroup = new FormGroup({
    method: new FormControl(1),
    amount: new FormControl(100, Validators.min(100))
  });

  public paymentOptions$ = of([
    {
      id: 1,
      value: 'PAYMENT_METHOD.CARDS'
    },
    {
      id: 2,
      value: 'PAYMENT_METHOD.YANDEX'
    }
  ]).pipe(
    map(options => {
      return options.map(({id, value}) => {
        return {
          id,
          value: this.translatePipe.transform(value)
        };
      });
    })
  );

  public get minValue(): number {
    return environment.paymentMinValue;
  }

  constructor(private dialog: MatDialogRef<PaymentDialogComponent>,
              private translate: TranslateService,
              private cd: ChangeDetectorRef) { }

  ngOnInit() {
  }

  public submit() {
    console.log('Payment');

    // TODO Mock
    this.dialog.close(true);
  }

}
